import { TextField, Autocomplete } from "@mui/material";
import { useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { getDisasters } from "../../../../../api";
import type { DisasterItem, DisasterSelectValue } from "../../../../../types/disaster";

type JoinDisasterSelectProps = {
  changedValue: (value: DisasterSelectValue) => void;
};

export default function JoinDisasterSelect({
  changedValue,
}: JoinDisasterSelectProps) {
  const searchParams = new URLSearchParams(useLocation().search);
  const disasterId = searchParams.get("disaster-id");

  const [disasters, setDisasters] = useState<DisasterItem[]>([]);

  const fetchDisasters = async () => {
    try {
      const response = await getDisasters({
        name: null,
        is_completed: false,
        exclude_id: disasterId,
        start_at_stt: null,
        start_at_end: null,
        order: null,
        sort: null,
        page: 1,
        limit: null,
      });
      if (response.status !== "ok") {
        return;
      }
      const data = response.disasters;
      if (data) {
        setDisasters(data);
      } else {
        console.error("ヒットするSSなし");
      }
    } catch (error) {
      console.error("API呼び出しエラー", error);
    }
  };

  useEffect(() => {
    fetchDisasters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Autocomplete
      fullWidth
      size="small"
      options={disasters}
      getOptionLabel={(disaster) => {
        if (typeof disaster === "string") {
          return disaster;
        }
        return disaster.name ?? "";
      }}
      renderOption={(props, option) => (
        <li {...props} key={option.id ?? props.key}>
          {option.name || "名称未設定"}
        </li>
      )}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      renderInput={(params) => (
        <TextField {...params} label="結合先災害選択" name="joinDisasterSelect" />
      )}
      onChange={(_event, newValues) => {
        changedValue({ id: newValues?.id, name: newValues?.name });
      }}
    />
  );
}
